import React, { useState, useEffect } from 'react';
import { Drawer, Button, Select, message, Input, Form, Spin, Card } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import FiltersDynamic from '../Components/FiltersDynamicComponent';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';

const { Option } = Select;

const DeleteRecordFlowDrawer = ({selectedNode, visible, onClose, nodeData, onSave }) => {
  const [objects, setObjects] = useState([]);
  const [fields, setFields] = useState([]);
  const [selectedObject, setSelectedObject] = useState(null);
  const [filters, setFilters] = useState([]); // Filter conditions for the Delete operation
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [apiName, setApiName] = useState('');
  const [description, setDescription] = useState('');
  const [logic, setLogic] = useState('');
  const [valueOperator, setValueOperator] = useState('');
  

  useEffect(() => {
    if (visible) {
      fetchObjects();
    }
  }, [visible]);

  useEffect(() => {
      if (nodeData && Object.keys(nodeData).length > 0) {
        // Set basic details
        setName(nodeData.name || "");
        setApiName(nodeData.apiname || "");
        setDescription(nodeData.description || "");
        setSelectedObject(nodeData.parameters?.model || null);
    
        // Set logic
        setLogic(nodeData.parameters?.logic_string || "");
    
        // Set conditions (filters)
        const existingFilters = nodeData.parameters.conditions
        ? Object.entries(nodeData.parameters.conditions).map(([key, { field, value }]) => {
          let operator = '';
          let actualValue = '';
          if (Object.keys(value)[0] !== "0") {
            operator = Object.keys(value)[0];
            actualValue = value[operator];
          } else {
            actualValue = value; // Extract the actual value (e.g., '50')
          }
          let op = '';
          if (operator !== '') {
            try {
              setValueOperator(operator);
              op = operator;
            } catch (error) {
              // Handle the error gracefully
              setValueOperator(''); // or any default value
            }
          } else {
            op = '';
          }
          return {
            field,
            value: value,
            displayValue: actualValue,
            operator: op
          };
        })
        : [{ field: '', value: '', operator: '' }];
      setFilters(existingFilters); // Set filters state here
    
        
    
        // Fetch fields for the selected object if available
        if (nodeData.parameters?.model) {
          fetchFields(nodeData.parameters.model);
        }
      }
      else{
        setName('');
        setApiName('');
        setDescription('');
        setSelectedObject(null);
        setFilters([]);
        // setSelectedFields({});
        // setFieldValues({});
    
      }
    }, [nodeData]);
  const fetchObjects = async () => {
    try {
      setLoading(true);
      const apiService = new ApiService(`${BASE_URL}/mt_objects`, { 'Content-Type': 'application/json' }, 'GET');
      const response = await apiService.makeCall();
      setObjects(response);
    } catch (error) {
      message.error('Failed to fetch objects.');
    } finally {
      setLoading(false);
    }
  };

  const fetchFields = async (objName) => {
    try {
      setLoading(true);
      const apiService = new ApiService(`${BASE_URL}/mt_fields/object/${objName}`, { 'Content-Type': 'application/json' }, 'GET');
      const response = await apiService.makeCall();
      setFields(response);
    } catch (error) {
      console.error('Error fetching fields:', error);
      message.error('Failed to fetch fields.');
    } finally {
      setLoading(false);
    }
  };

  const handleObjectChange = (value) => {
    setSelectedObject(value);
    fetchFields(value);
    setFilters([]); // Reset filters when changing the object
  };

  const handleSave = () => {
    if (!name || !apiName || !selectedObject || filters.length === 0) {
      message.error('Please fill all required fields and add filters.');
      return;
    }
    const filterObj = filters.reduce((acc, filter, index) => {
      if (filter.field) {
        acc[index + 1] = {
          field: filter.field,
          value: filter.value
        }; 
      }
      return acc;
    }, {});
    const type = "Delete Records";
    const data = {
      name,
      apiName,
      description,
      selectedObject,
      filterObj, // Include filters in the data for deletion
      logic,
      type
    };

    // Convert data to JSON and pass it to the parent component
    const jsonData = JSON.stringify(data);
    
    // Send the data to the parent FlowUI component
    onSave(selectedNode.id,jsonData); // Pass JSON data to parent component
    message.success('Delete Record saved successfully!');
    onClose();
  };

  return (
    <Drawer
      title={`Delete Records`}
      placement="right"
      onClose={onClose}
      visible={visible}
      zIndex={1002}   // higher than sidebar
      width={600}
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button type="default" onClick={onClose}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleSave}>
            Save
          </Button>
        </div>
      }
      footerStyle={{ textAlign: 'right' }}
    >
      {loading ? (
        <Spin tip="Loading..." />
      ) : (
        <Form layout="vertical">
          <Form.Item label="Name" required>
            <Input
              placeholder="Enter name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onBlur={() => {
                if (name) {
                  setApiName(
                    name
                      .replace(/[^a-zA-Z0-9]/g, "") // Remove special characters
                      .replace(/\s+/g, "") // Remove spaces
                      .trim()
                  );
                }
              }}          
            />
          </Form.Item>

          <Form.Item label="API Name" required>
            <Input
              placeholder="Enter API name"
              value={apiName}
              onChange={(e) => setApiName(e.target.value)}
            />
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              placeholder="Enter description"
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Item>

          <Form.Item label="Select Object" required>
            <Select
              placeholder="Select Object"
              style={{ width: '100%' }}
              onChange={handleObjectChange}
              value={selectedObject}
            >
              {objects.map((obj) => (
                <Option key={obj.name} value={obj.name}>
                  {obj.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {selectedObject && (
            <FiltersDynamic
              fields={fields}
              filters={filters}
              setFilters={setFilters}
              logic={logic}
              setLogic={setLogic}
              setValueOperator={setValueOperator}
              valueOperator={valueOperator}
              fetchLookupRecords={() => {}}
              fetchLookupRecordsForExistingFilters={() => {}}
            />
          )}
        </Form>
      )}
    </Drawer>
  );
};

export default DeleteRecordFlowDrawer;
